var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.preloader)?_c('preloader',{attrs:{"margin":"30px"}}):_c('system-activity',{attrs:{"campaigns-id":[_vm.campaign.campaign_id],"date-range":_vm.dateRange,"tab":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }